import React, { useContext, useEffect } from "react";
import { Route } from "react-router-dom";

import { ApplicationContextProvider } from "@swa-ui/application";
import { ThemeProvider } from "@swa-ui/design-tokens";
import { DotcomPageLayout } from "@swa-ui/dotcom";
import {
  FlightDataProvider,
  InflightPageFooter,
  InflightWifiHeader,
  WifiAuthenticationContext,
} from "@swa-ui/inflight";
import { PlacementsContext } from "@swa-ui/placements";

import { HomePage } from "../../pages/HomePage";
import { InflightUserStatusContext } from "../../providers";
import { ErrorPage } from "../ErrorPage";
import { LoadingShimmer } from "../LoadingShimmer";

const basePath = "/inflight/home-page";
const PARAMETER_PROVIDER_KEY = "pageContext";

export const InflightHomePageContainer = () => {
  const { registerParameterProvider } = useContext(PlacementsContext);
  const { wifiAuthenticationState } = useContext(WifiAuthenticationContext);
  const { error, loading, sandboxStatus } = useContext(InflightUserStatusContext);

  useEffect(() => {
    registerParameterProvider(PARAMETER_PROVIDER_KEY, () => ({
      loginState: wifiAuthenticationState,
    }));
  }, [wifiAuthenticationState]);

  return error ? (
    <ThemeProvider themeName="customer">
      <ErrorPage />
    </ThemeProvider>
  ) : (
    <ApplicationContextProvider
      context={{ footer: <InflightPageFooter />, header: <InflightWifiHeader /> }}
    >
      <DotcomPageLayout>
        {loading ? (
          <LoadingShimmer />
        ) : (
          <FlightDataProvider sandboxStatus={sandboxStatus}>
            <>
              <Route path={`${basePath}/`} exact>
                <HomePage />
              </Route>
              <Route path={`/`} exact>
                <HomePage />
              </Route>
            </>
          </FlightDataProvider>
        )}
      </DotcomPageLayout>
    </ApplicationContextProvider>
  );
};
